import {Fragment, useEffect, useState} from 'react';

import {StoreService as Service} from './StoreService';

import {useToolbar} from '../../../shared/hooks/Toolbar';
import {useDataTable} from '../../../shared/hooks/DataTable';
import {useDialogCrup} from '../../../shared/hooks/DialogCrup';
import {ConfirmDialogService} from '../../../AppConfirmDialog';
import {useTranslation} from '../../../shared/language';
export const List = () => {

  const {t} = useTranslation();
  const header = t('menu.petrolStore');
  const dataKey = 'id';
  const [manyActions, setManyActions] = useState([]);
  const {render: renderDataTable, refreshLazyData, reloadLazyData, selectedItems, dataTableParams} = useDataTable({
    header,
    dataKey,
    columns: [
      {field: 'code', header: t('catalog.petrolStoreCode'), width: 200, matchMode: 'contains'},
      {field: 'storeName', header: t('catalog.petrolStoreName'), minWidth: 220, matchMode: 'contains'},
      {field: 'storeAddress', header: t('catalog.petrolStoreAddress'), minWidth: 220, matchMode: 'contains'},
      {field: 'uRlUpdatePrice', header: t('catalog.priceUpdateLink'), width: 150, matchMode: 'contains'},
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      return Service.getList(params);
    }
  });
  useEffect(() => {
    refreshToolbar();
  }, [selectedItems]); // eslint-disable-line react-hooks/exhaustive-deps

  const {render: renderDialogCrup, create, update, clone, getValue, setValue, touched} = useDialogCrup({
    header,
    dataKey,
    width: '60rem',
    fields: [
      {field: 'code', header: t('catalog.petrolStoreCode'), required: true, uppercase: true, InputTextProps: {maxLength: 50}, className: 'md:col-4'},
      {field: 'storeName', header: t('catalog.petrolStoreName'), required: true, InputTextProps: {maxLength: 500}, className: 'md:col-12'},
      {field: 'storeAddress', header: t('catalog.petrolStoreAddress'), required: true, InputTextProps: {maxLength: 500}, className: 'md:col-12'},
      {field: 'uRlUpdatePrice', header: t('catalog.priceUpdateLink'), required: true, InputTextProps: {maxLength: 500}, className: 'md:col-12'},
    ],
    createItem: (item) => {
      return Service.create(item);
    },
    updateItem: (id, item) => {
      return Service.update(id, item);
    },
    refreshLazyData
  });


  const {renderToolbar, refreshToolbar} = useToolbar({
    dataKey, create,
    update: (item) => {
      Service.get(item[dataKey]).then(data => {
        if (data.price > 0) {
          data.listPrice = data.price;
        }
        if (data.ratioTax > 0 && data.price > 0) {
          data.listPrice = Math.round(data.price * (1 + data.ratioTax / 100));
        }
        update(data);
      });
    },
    clone: (item) => {
      Service.get(item[dataKey]).then(data => {
        clone(data);
      });
    },
    reloadLazyData, selectedItems,
    deleteItem: (id) => {
      return Service.delete(id);
    },
    otherActions: [
      ...manyActions,
    ]
  });

  const onAddSelectedItems = (items) => {
    let InvoiceIdArray;
    if (Array.isArray(items) && items.length) {
      InvoiceIdArray = items.map(({id}) => id);
    }

    if (!InvoiceIdArray || InvoiceIdArray.length < 1) {
      ConfirmDialogService.showInvalid(t('validation.selectDevice'));
      return;
    }
  }

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {renderDialogCrup()}
    </Fragment>
  )
}
